import { render, staticRenderFns } from "./Pagination.component.vue?vue&type=template&id=1d58e8e8&scoped=true&"
import script from "./Pagination.component.vue?vue&type=script&lang=js&"
export * from "./Pagination.component.vue?vue&type=script&lang=js&"
import style0 from "./Pagination.component.vue?vue&type=style&index=0&id=1d58e8e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d58e8e8",
  null
  
)

export default component.exports